import Loadable from 'react-loadable';

export const ProjectsEmptyOrNonProvisionedState = Loadable({
  loader: () => import(/* webpackChunkName: "ProjectsEmptyOrNonProvisionedState" */ './EmptyOrNonProvisionedState'),
  loading: () => null,
});
